module.exports = __webpack_public_path__ + "static/2EcoSafe-e03e91fd6c9cfe7973cf0327b588e221.pdf";